import { defineComponent } from "vue";

export default defineComponent({
  name: "SystemSettings",
  props: {},
  components: {}
  // setup(props) {},
});
